import {API_ENDPOINT}  from "./Api";
import requestInstance from "./Request";
import { setCurrentUser } from "utils/utils";

let env = process.env.REACT_APP_B2B_API_BASE_URL

//Login Service
export const loginApi = async(user) => {
  const data = user || {};
  const res = await requestInstance.post(`${env}${API_ENDPOINT.Login.api}`, data)
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}

//Logout Service
export const logoutApi = async() => {
  const res = await requestInstance.post(`${env}${API_ENDPOINT.Logout.api}`)
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}

//OTP Service
export const otpApi = async(user) => {
    const data = user || {};
    const res = await requestInstance.post(`${env}${API_ENDPOINT.Otp.api}`, data)
    .catch((err) => err.response)
    return setCurrentUser(res)
  }

//Country code list
export const countryCodeApi = async() => {
  const res = await requestInstance.get(`${env}${API_ENDPOINT.CountryList.api}`)
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}
  